<template>
<div>
  <BER :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" alpha="XM3"></BER>
  <!-- <BER :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0" alpha="XM2"></BER> -->
</div>
</template>

<script>
import BER from "../../components/BER-ColumnAlpha";

import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    BER,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
